export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 pb-12 md:pb-0">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full bg-accent-100/30 blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                热门吃瓜 · 实时更新
              </div>

              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
                51吃瓜网入口
                <span className="block text-primary-500 mt-1">最新吃瓜资讯一站式聚合平台</span>
              </h1>

              <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
                全网热点吃瓜内容快速直达，安全稳定随时访问
              </p>

              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-xl lg:max-w-none">
                51吃瓜网入口是全网领先的吃瓜内容聚合导航平台，汇集最新娱乐八卦、明星动态、综艺热议、网红热点等多元吃瓜资讯。我们实时更新51吃瓜网站入口与51吃瓜网址，提供稳定的官方入口和在线访问方案，帮助用户快速解决51吃瓜网怎么进的问题。无论是追踪热门话题还是探索深度专题，51吃瓜网入口以安全稳定的一站式服务，让吃瓜更简单、更畅快。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
                <div className="text-center">
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">1000+</div>
                  <div className="text-xs text-foreground-500 mt-1">每日更新内容</div>
                </div>
                <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
                <div className="text-center">
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">15+</div>
                  <div className="text-xs text-foreground-500 mt-1">内容分类覆盖</div>
                </div>
                <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
                <div className="text-center">
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">7×24</div>
                  <div className="text-xs text-foreground-500 mt-1">全天候实时更新</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#cards"
                  onClick={(e) => handleNavClick(e, '#cards')}
                  className="w-full sm:w-auto px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  立即浏览热门吃瓜
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <a
                  href="#topics"
                  onClick={(e) => handleNavClick(e, '#topics')}
                  className="w-full sm:w-auto px-8 py-3.5 rounded-md border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  探索热门话题
                  <i className="ri-hashtag ml-2"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20geometric%20composition%20with%20warm%20coral%20and%20amber%20gradients%2C%20flowing%20organic%20shapes%20representing%20trending%20social%20media%20buzz%20and%20entertainment%20news%2C%20clean%20modern%20design%20with%20overlapping%20translucent%20circles%20and%20dynamic%20wave%20patterns%2C%20editorial%20digital%20art%20style%20with%20soft%20glow%20effects%2C%20warm%20atmosphere&width=1000&height=750&seq=hero-main-visual-2026&orientation=landscape"
                  alt="51吃瓜网入口 - 最新吃瓜资讯聚合平台主视觉"
                  className="w-full h-full object-cover"
                  title="51吃瓜网入口主视觉"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}